import { createAction } from 'redux-actions';
export var SET_REASON = 'SET_REASON';
export var setReason = createAction(SET_REASON, function (reason) { return reason; });
